<template>
  <div>
    <div class="w-100 d-flex justify-content-end my-1">
      <b-button
        class="mr-1"
        variant="outline-success"
        @click="openAddBonusModal({}, 'create')"
      >
        <div class="d-flex justify-content-between">
          <span> {{ $t("CREATE") }} </span>
        </div>
      </b-button>
    </div>

    <filter-slot
      :filter="[]"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      :no-visible-principal-filter="true"
      @reload="$refs['reft-bonus-table'].refresh()"
    >
      <template #table>
        <b-table
          ref="reft-bonus-table"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="fields"
          primary-key="id"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>

          <!-- <template #cell(actions)="data"> -->
          <!-- <div>
              <feather-icon
                icon="EditIcon"
                v-b-tooltip.hover.left="$t('Edit')"
                class="text-warning cursor-pointer ml-2"
                size="20"
                @click="openAddBonusModal(data.item, 'edit')"
              />
            </div> -->
          <!-- </template> -->
        </b-table>
      </template>
    </filter-slot>

    <AddBonusModal
      v-if="showModal"
      :bonus="currentBonus"
      :method="method"
      @onlyClose="showModal = false"
      @closeReload="closeRefresh"
    />
  </div>
</template>

<script>
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import SettingsBonusService from "@/views/settings/views/payroll/components/bonus/service/setting-bonus.service.js";
import AddBonusModal from "@/views/settings/views/payroll/components/bonus/AddBonusModal.vue";

export default {
  components: {
    FilterSlot,
    AddBonusModal,
  },
  computed: {
    fields() {
      return [
        {
          key: "name",
          sortable: true,
          label: this.$t("name"),
        },
        {
          key: "amount",
          sortable: true,
          label: this.$t("Amount"),
          tdClass: "ml-3",
        },
        {
          key: "created_by",
          sortable: false,
          label: this.$t("created by"),
        },
        {
          key: "created_at",
          sortable: true,
          label: this.$t("created at"),
        },
        {
          key: "actions",
          label: this.$t("actions"),
        },
      ];
    },
  },
  data() {
    return {
      showModal: false,
      method: "create",
      currentBonus: null,

      isBusy: false,
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        per_age: 10,
        current_age: 1,
      },
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "SEARCH...",
        model: "",
      },
    };
  },
  methods: {
    async myProvider(ctx) {
      try {
        let order = 1;
        switch (ctx.sortBy) {
          case "name":
            order = 1;
            break;
          case "amount":
            order = 4;
            break;
          case "created_at":
            order = 7;
            break;
          default:
            order = 1;
            break;
        }
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          order: order,
          orderby: ctx.sortDesc ? "Desc" : "Asc",
          search_txt: this.filterPrincipal.model,
          type: "",
        };
        const { data } = await SettingsBonusService.listBonus(params);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data;
      } catch (error) {
        console.log(error);
      }
    },

    openAddBonusModal(item, type) {
      this.currentBonus = item;
      this.method = type;
      this.showModal = true;
    },

    closeRefresh: function () {
      this.showModal = false;
      this.$refs["reft-bonus-table"].refresh();
    },
  },
};
</script>

<style>
</style>